import React from 'react'

import Base from '../_Base'

const Feedback = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M22 1.2v17h-5.5L12 22.8l-4.5-4.6H2v-17h20zm-2 1.9H4v13h4.4l3.6 3.8 3.6-3.7H20V3.1zM12 9a1.4 1.4 0 1 1 0 2.8A1.4 1.4 0 0 1 12 9zm4.4 0a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8zM7.6 9a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8z"
      fillRule="evenodd"
    />
  </Base>
)

export default Feedback
